import { render } from "./car_1.vue?vue&type=template&id=0ec57eac&scoped=true"
const script = {}

import "./car_1.vue?vue&type=style&index=0&id=0ec57eac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec57eac"]])

export default __exports__